import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import '../App.css';

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Sidebar />
      <div style={{ marginLeft: '200px', padding: '2rem' }}>
        <div style={styles.cardGrid}>
          <div style={styles.card}>
            <h2 style={styles.cardTitle}>Start New Project</h2>
            <p style={styles.cardText}>
              Create a new building recertification project and complete the project intake form.
            </p>
            <button
              className="main-content-button"
              style={styles.cardButton}
              onClick={() => navigate('/project/new')}
            >
              New Project
            </button>
          </div>
          <div style={styles.card}>
            <h2 style={styles.cardTitle}>My Projects</h2>
            <p style={styles.cardText}>
              View and continue working on your existing recertification projects.
            </p>
            <button
              className="main-content-button"
              style={styles.cardButton}
              onClick={() => navigate('/projects')}
            >
              View Projects
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const styles = {
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '1.5rem',
  },
  card: {
    backgroundColor: 'rgba(255,255,255,0.92)',
    borderRadius: '8px',
    padding: '1.5rem',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  },
  cardTitle: {
    margin: '0 0 0.75rem',
    color: '#112b49',
    fontSize: '1.2rem',
  },
  cardText: {
    color: '#555',
    fontSize: '0.9rem',
    marginBottom: '1.25rem',
    lineHeight: '1.5',
  },
  cardButton: {
    width: '100%',
    padding: '0.65rem',
    fontSize: '1rem',
    cursor: 'pointer',
  },
};

export default Dashboard;